import { Error } from "@components/error";
import useTranslation from "@hooks/use_translation";
import React from "react";

const handleReload = (e: React.MouseEvent) => {
  e.preventDefault();
  window.location.reload();
};

const OtherError = () => {
  const { t } = useTranslation("misc");
  return (
    <Error
      header={t("otherError.header")}
      message={t("otherError.body1")}
      link={{
        href: window.location.href,
        label: t("otherError.cta"),
        onClick: handleReload,
      }}
    />
  );
};

export default OtherError;
